export const SET_PROFILE_DATA = "SET_PROFILE_DATA";

//organisation
export const SET_ORGANISATION_DATA = "SET_ORGANISATION_DATA";
export const SET_ORGANISATION_LOGO = "SET_ORGANISATION_LOGO";
export const LOAD_INDUSTRY_LIST = "LOAD_INDUSTRY_LIST";
export const LOAD_ORG_DISTRIBUTOR_LIST = "LOAD_ORG_DISTRIBUTOR_LIST";
export const LOAD_ORG_DATA = "LOAD_ORG_DATA";
export const LOAD_ORG_PARENT_COMPANY_LIST = "LOAD_ORG_PARENT_COMPANY_LIST";
export const LOAD_ORG_LANGUAGE_LIST = "LOAD_ORG_LANGUAGE_LIST";
export const LOAD_ORG_COUNTRY_LIST = "LOAD_ORG_COUNTRY_LIST";
export const LOAD_ORGANISATION_OPTIONS = "LOAD_ORGANISATION_OPTIONS";
export const LOAD_CURRENCY_CODES = "LOAD_CURRENCY_CODES";
export const SET_KYC_BG = "SET_KYC_BG";
//organisation

//team_profile
export const SET_TEAM_PROFILE_DATA = "SET_TEAM_PROFILE_DATA";

//child partners
export const CHILD_PARTNERS_FETCHING_INIT = "CHILD_PARTNERS_FETCHING_INIT";
export const CHILD_PARTNERS_FETCHING_INIT_COMPLETE =
  "CHILD_PARTNERS_FETCHING_INIT_COMPLETE";
export const CHANGE_CHANNEL_PARTNER_PAGE = "CHANGE_CHANNEL_PARTNER_PAGE";
export const SEARCH_CHANNEL_PARTNER = "SEARCH_CHANNEL_PARTNER";
export const SEARCH_RESELLERS = "SEARCH_RESELLERS";
export const RESELLERS_FETCHING_INIT = "RESELLERS_FETCHING_INIT";
export const RESELLERS_FETCHING_INIT_COMPLETE =
  "RESELLERS_FETCHING_INIT_COMPLETE";
export const CHANGE_RESELLERS_PAGE = "CHANGE_RESELLERS_PAGE";
export const SET_CHILD_PARTNER_DATA = "SET_CHILD_PARTNER_DATA";
export const SET_RESELLERS_DATA = "SET_RESELLERS_DATA";
